<template>
  <base-row
    v-bind="$props"
    :selectable="false"
  >
    <td class="w-1/4">
      {{ item.display_type ? item.display_type : '-' }}
    </td>
    <td class="w-1/4">
      {{ item.display_method ? item.display_method : '-' }}
    </td>
    <td class="w-1/4">
      {{ item.amount ? _dollars(item.amount) : '-' }}
    </td>
    <td class="w-1/4">
      {{ item.paid_at ? _datetime(item.paid_at) : '-' }}
    </td>
  </base-row>
</template>

<script>
import TableRow from '@/Components/Table/TableRow'
import RowProps from '@/Components/Table/Mixins/RowProps'
import BasicBadge from '@/Components/Badges/BasicBadge.vue'
import _dollars from '@/Filters/Dollars'
import _datetime from '@/Filters/DateTime'

export default {
  components: {
    'base-row': TableRow,
    BasicBadge
  },

  mixins: [RowProps],

  methods: {
    _dollars,
    _datetime
  }
}
</script>
